export default "<div [hidden]=\"!loading\" class=\"page-loader\">\n    <img src=\"../../assets/images/page-loader.gif\" />\n</div>\n "